import React, { useContext, useState, useEffect } from 'react';
import {
    Table,
    Dropdown,
    Button,
    Tooltip,
    TableFooter,
    DeleteConfirmation
} from 'components';
import './index.scss';
import { useTranslation } from 'react-i18next';
import { ActiveShipmentsContext, CollaboratorsContext, AuthContext, DocumentsContext, HomeContext, ModalContext, ShipmentInfoContext } from 'contexts';
import { typeAddDocument, convertDate } from 'utils';
import { COGNITO_USER_ID, COLLABORATORS_PAGE_SIZE, StatusTradeTrust } from 'actions';
import { useLocation } from 'react-router-dom';
import { Collaborators } from '../components';

export const DocumentSignature = () => {
    const [t] = useTranslation();
    const { setUploadSignatureDocuments,
        setPreviewSignatureDocument,
        // setEthereumDocument,
        setVerifyWalletModal,
        removeDoc,
        setRemoveDoc,
        setPreviewDocument,
        // setAssignMemberToDocument,
        setViewExtractedInfo,
        setAssignMemberToDocumentV2
    } = useContext(ModalContext);
    const { setDocumentPermission } = useContext(DocumentsContext);
    const {
        setIdDocumentSignature,
        setFileId,
        shipment,
        reloadDocument,
        documentAwaitBlockChain,
        setDocumentAwaitBlockChain,
        setIdShipment,
        setNotificationMessage,
        setIsDocument,
        setDocumentId,
        setMemberSelectedForDocument,
        refreshDocumentSignature,
        // setRefreshDocumentSignature,
        awaitDocuments,
        setOcrDocSignature,
        setCreatedByDoc,
        setDocType,
        // setCurrentStatus
    } = useContext(HomeContext);
    const { doGetDocumentsSignatureList, totalPagesDoc, currentPageDoc, documents, setDocuments, doDeleteDocumentSignature } = useContext(ShipmentInfoContext);
    const { doGetSign, doGetAllEthereumDetail, doGetSignatureDocumentResult, doGetwallets } = useContext(ActiveShipmentsContext);
    const { doGetCollaborators, collaborators } = useContext(CollaboratorsContext);
    const { userInfo } = useContext(AuthContext);
    // const [removeDoc, setRemoveDoc] = useState(false);
    const location = useLocation();
    const pathnameArr = location.pathname.split('/');
    const shipmentId = pathnameArr[pathnameArr.length - 2];
    // const [genaters, setGenaters] = useState([]);
    const [documentNameDelete, setDocumentNameDelete] = useState();
    const [deleteDocumentID, setDeleteDocumentID] = useState();

    /*eslint-disable */
    useEffect(() => {
        doGetwallets();
    }, []);

    useEffect(() => {
        doGetDocumentsSignatureList({
            shipmentId: shipmentId,
            page: currentPageDoc,
            limit: 6,
            sortBy: [
                {
                    sortBy: "updateDate",
                    sortType: "DESC"
                },
                {
                    sortBy: "createdDate",
                    sortType: "DESC"
                }
            ]
        }, (data) => {
            setDocuments(data);
            doGetAllEthereumDetail(true, data, shipment?.orgId, (documentDetails) => {
                data?.map(item => {
                    const data = documentDetails?.find(x => x._id === item.documentId);
                    item.url = data?.downloadSignedURI?.itemURI;
                    return item;
                });
                const result = data?.map(item => {
                    let tradeTrust = documentDetails?.find(x => x.fileRecordId === item.documentId)?.tradeTrust;
                    if (tradeTrust) {
                        item.blockchain = tradeTrust?.network?.blockchain;
                        item.status = tradeTrust.status
                    }
                    return item;
                });
                setDocuments(result);
                // setRefreshDocumentSignature(false);
            });
        })
    }, [refreshDocumentSignature, shipment]);

    useEffect(() => {
        const updateStatus = () => {
            let number = 0;
            const interval = setInterval(() => {
                number = number + 1;
                if (documentAwaitBlockChain.length > 0) {
                    let oldDocument = [...documents];
                    doGetAllEthereumDetail(false, documentAwaitBlockChain, shipment?.orgId, (documentDetails) => {
                        const index = oldDocument.findIndex(x => x.documentId === documentAwaitBlockChain[0].documentId);
                        let data = oldDocument.find(x => x.documentId === documentAwaitBlockChain[0].documentId);
                        data.blockchain = documentDetails[0]?.tradeTrust?.network?.blockchain;
                        data.status = documentDetails[0]?.tradeTrust?.status;
                        if(index > 0 || index === 0) oldDocument[index] = data;
                        if(documentDetails[0]?.tradeTrust?.status !== StatusTradeTrust.ISSUING_STARTED) {
                            setDocumentAwaitBlockChain([]);
                            clearInterval(interval);
                        }
                    });
                    setDocuments(oldDocument);
                }
            }, 20000);
        }
        updateStatus();
    }, [documentAwaitBlockChain.length > 0]);

    useEffect(() => {
        if (reloadDocument) {
            const arrayDoc = [...documents];
            let docIndex = arrayDoc.findIndex(x => x.documentId === reloadDocument.ret._id);
            let doc = arrayDoc.find(x => x.documentId === reloadDocument.ret._id);
            doc.blockchain = reloadDocument?.ret?.tradeTrust?.network?.blockchain;
            doc.status = reloadDocument?.ret?.tradeTrust?.status;
            arrayDoc[docIndex] = doc;
            setDocuments(arrayDoc);
        }
    }, [reloadDocument]);
    /*eslint-enable */

    const handlePageChange = page => {
        const payload = {
            shipmentId: shipmentId,
            page: page + 1,
            limit: 6,
            sortBy: [
                {
                    sortBy: "updateDate",
                    sortType: "DESC"
                },
                {
                    sortBy: "createdDate",
                    sortType: "DESC"
                }
            ]
        };
        doGetDocumentsSignatureList(payload, (data) => {
            setDocuments(data);
            doGetAllEthereumDetail(true, data, shipment?.orgId, (documentDetails) => {
                const result = data?.map(item => {
                    let tradeTrust = documentDetails?.find(x => x.fileRecordId === item.documentId)?.tradeTrust;
                    if (tradeTrust) {
                        item.blockchain = tradeTrust?.network?.blockchain;
                        item.status = tradeTrust.status
                    }
                    return item;
                });
                setDocuments(result);
            })
        })
    }

    const handleGetSign = (id) => {
        doGetSign(id, (data) => {
            window.open(data.url);
        })
    }

    const handleViewResult = (id) => {
        doGetSignatureDocumentResult(id, (data) => {
            let pdfWindow = window.open("");
            pdfWindow.document.write(`<iframe width='100%' height='100%' src='${data.url}'></iframe>`);

        })
    }

    const checkRequestSignature = (envelopeId, createdBy) => {
        if(envelopeId) {
            return true
        } else {
            console.log((collaborators.filter(collab => collab?.roles.includes("SHIPMENT_ADMIN")).some(each => each?.collaboratorId === userInfo?._id) || createdBy.cognitoUserId === sessionStorage.getItem(COGNITO_USER_ID)));
            return !(collaborators.filter(collab => collab?.roles.includes("SHIPMENT_ADMIN")).some(each => each?.collaboratorId === userInfo?._id) || createdBy.cognitoUserId === sessionStorage.getItem(COGNITO_USER_ID))
        }
    }

    const chooseTypeGenerateDoc = (type, id) => {
        setViewExtractedInfo(true);
        setOcrDocSignature(true);
        setDocumentPermission(true);
        setFileId(id);
        // setGenaters([...genaters, { documentId: id }]);
        setIdDocumentSignature(id);
        // if (type.key === "2") {
        //     setEthereumDocument(true);
        // }
    }

    const handleRequestSignature = (documentId, idDocumentSignature) => {
        setIdDocumentSignature(idDocumentSignature);
        setFileId(documentId);
        setPreviewSignatureDocument(true);

    }

    const handlePreviewDocument = (documentId, idDocumentSignature, sub, type) => {
        setDocType({sub: sub, type: type});
        setPreviewDocument(true);
        setIdDocumentSignature(idDocumentSignature);
        setFileId(documentId);
    }

    const handleRemoveDoc = (documentName, documentId) => {
        setRemoveDoc(true)
        setDocumentNameDelete(documentName);
        setDeleteDocumentID(documentId)
    }

    const handleAssignTask = (shipmentId, documentId, partners, createdBy) => {
        setDocumentId(documentId);
        setCreatedByDoc(createdBy);
        // setAssignMemberToDocument(true);
        setAssignMemberToDocumentV2(true);
        setIsDocument(true);
        setMemberSelectedForDocument(partners)
        doGetCollaborators(shipmentId, {
            page: 0,
            limit: COLLABORATORS_PAGE_SIZE,
            // role: roles.map(role => role.role)
        });
    }

    const deleteDoc = () => {
        if (deleteDocumentID) {
            doDeleteDocumentSignature(deleteDocumentID, () => {
                let newDocuments = documents.filter(item => item._id !== deleteDocumentID);
                setRemoveDoc(false);
                setNotificationMessage(`
                    <p> Document has been deleted successfully!</p>
                `);
                setDocuments(newDocuments);
            })
        }
    }

    const columns = [
        {
            dataIndex: 'documentName,documentExtension,documentId,_id',
            render: (documentName, documentExtension, _id) =>
                <>
                    <div className="d-flex align-items-center justify-content-between">
                        <i className="icon-paperclip tr__document-signature--icon-name" />
                            <p>{documentName}.{documentExtension}</p>
                    </div>
                </>
        },
        {
            dataIndex: 'type,subType',
            render: (type, subType) => (
                <div className="d-flex flex-column tr__document-signature--type">
                    <p className="h6 mbx1">{subType.replace(/-/g, " ")}</p>
                    <h6 className="h6 mbx1">{type.replace(/-/g, " ")}</h6>
                </div>
            )
        },
        {
            dataIndex: 'createdBy,createdDate,updatedDate',
            render: (createdBy, updatedDate) => (
                <div>
                    <Tooltip renderContent={() => (
                        <div>
                              <p>{createdBy?.name ? createdBy?.name : createdBy?.email}</p>
                        </div>
                    )}>
                        <h6 className="h6 mbx1">{createdBy.name}</h6>
                        <p>{convertDate(updatedDate, ('DD MMM YYYY | hh:mm:ss A'))}</p>
                    </Tooltip>
                </div>
            )
        },
        {
            dataIndex: '_id,partners,createdBy',
            render: (_id, partners, createdBy) => (
                <Collaborators
                    members={partners}
                    onAdd={() => handleAssignTask(shipmentId, _id, partners, createdBy)}
                    skip={3}
                    isDocument={true}
                    label={t("template.my-template.detail.assign")}
                />
            )
        },
        {
            dataIndex: 'status,blockchain',
            render: (status, blockchain) => (
                <>
                    <div className="d-flex align-items-center justify-content-between">
                        <div className={`h6 text-capitalize status ${status}`}>
                            <Tooltip content={status}>
                                <p className="f-medium">{status}</p>
                            </Tooltip>
                        </div>
                        <div className={`h6 text-capitalize ${blockchain}`}>
                            <Tooltip content={blockchain}>
                                <p>{blockchain}</p>
                            </Tooltip>
                        </div>
                    </div>
                </>
            )
        },
        {
            dataIndex: 'documentId,_id,createdBy,signers,status,envelopeId,documentName,url,partners,subType,type',
            render: (documentId, _id, createdBy, signers, status, envelopeId, documentName, url, partners, subType, type) => (
                <div className="col-12 d-flex">
                    <div className="col">
                        <a href={url}>
                            <Tooltip content="Download">
                                <Button
                                    type="secondary"
                                    className="outline icon mrx1 tr__document-signature--btn-download"
                                    icon="icon-download"
                                />
                            </Tooltip>
                        </a>
                    </div>
                    <div className="col">
                        <Tooltip content="Delete">
                            <Button
                                type="danger"
                                className="icon mrx1 tr__document-signature--btn-delete outline"
                                icon="icon-trash"
                                onClick={() => handleRemoveDoc(documentName, _id)}
                                disabled={!(collaborators.filter(collab => collab?.roles.includes("SHIPMENT_ADMIN")).some(each => each?.collaboratorId === userInfo?._id) || createdBy.cognitoUserId === sessionStorage.getItem(COGNITO_USER_ID))}
                            />
                        </Tooltip>
                    </div>
                    <div className="col">
                        <Tooltip content="Preview">
                            <Button
                                type="primary"
                                className="icon mrx1 tr__document-signature--btn-preview"
                                icon="icon-eye"
                                onClick={() => handlePreviewDocument(documentId, _id, subType, type)}
                            />
                        </Tooltip>
                    </div>
                    <div className="col">
                        <Tooltip content="Request Signature">
                            <Button
                                type="secondary"
                                className="icon outline mrx1 tr__document-signature--btn-request-signature"
                                icon="icon-sign"
                                onClick={() => handleRequestSignature(documentId, _id)}
                                disabled={checkRequestSignature(envelopeId, createdBy)}
                            />
                        </Tooltip>
                    </div>
                    <div className="col">
                        <Tooltip content="Sign">
                            <Button
                                type="secondary"
                                className="outline icon mrx1"
                                icon="icon-signature"
                                onClick={() => { handleGetSign(_id) }}
                                disabled={!(signers.some(signer => signer.cognitoUserId === sessionStorage.getItem(COGNITO_USER_ID) && signer.status !== "SIGNED"))}
                            />
                        </Tooltip>
                    </div>
                    <div className="col">
                        <Tooltip content={`${signers.filter(e => e.status === "SIGNED").length}/${signers.length} SIGNED`}>
                            <Button
                                type="secondary"
                                className="outline mrx1 tr__document-signature--btn-signed"
                                onClick={() => handleViewResult(_id)}
                                disabled={!(envelopeId && createdBy.cognitoUserId === sessionStorage.getItem(COGNITO_USER_ID))}
                            >
                                {signers.filter(e => e.status === "SIGNED").length}/{signers.length}
                            </Button>
                        </Tooltip>
                    </div>
                    {(status === StatusTradeTrust.ISSUING_STARTED) ?
                        <div className="col tr__document-signature--generateTT">
                            <Dropdown
                                className="select tr__document-signature--generateTT select-generate"
                                mode="select"
                                disabled={true}
                                dropdownPosition="center"
                                placeholder="Generate TT"
                                options={typeAddDocument.map((l) => {
                                    return {
                                        ...l,
                                        value: l.value
                                    }
                                })}
                                onChange={value => chooseTypeGenerateDoc(value, documentId)} />
                        </div>
                        : (status === StatusTradeTrust.ISSUED || status === StatusTradeTrust.NEW_OWNER_ENDORSED ||
                            status === StatusTradeTrust.NEW_OWNER_ENDORSEMENT_FAILED ||
                            status === StatusTradeTrust.NEW_OWNER_ENDORSEMENT_STARTED ||
                            status === StatusTradeTrust.NEW_OWNER_NOMINATED ||
                            status === StatusTradeTrust.NEW_OWNER_NOMINATION_FAILED ||
                            status === StatusTradeTrust.NEW_OWNER_NOMINATION_STARTED ||
                            status === StatusTradeTrust.SERRENDERED ||
                            status === StatusTradeTrust.SERRENDERED_FAILED ||
                            status === StatusTradeTrust.SERRENDER_STARTED ||
                            status === StatusTradeTrust.HOLDER_TRANSFERRED ||
                            status === StatusTradeTrust.HOLDER_TRANSFER_FAILED ||
                            status === StatusTradeTrust.HOLDER_TRANSFER_STARTED ||
                            status === StatusTradeTrust.REVOKED ||
                            status === StatusTradeTrust.CONSUMED) ?
                            <div className="tr__document-signature--btn-request-manage">
                                <Button
                                    type="secondary"
                                    className="outline"
                                    onClick={() => {
                                        showDetails(documentId, status);
                                        setIdDocumentSignature(documentId);
                                    }}
                                >
                                    <p>Manage</p>
                                </Button>
                            </div> : (status === undefined && awaitDocuments.some(x => x.documentId === documentId)) ?
                                <div className="tr__document-signature--btn-request-please">
                                    <Tooltip content="Please wait">
                                        <Button
                                            type="secondary"
                                            className="outline"
                                            disabled={true}
                                        >
                                            <p className="has-tooltip">Please wait</p>
                                        </Button>
                                    </Tooltip>
                                </div> :
                                <div className="col tr__document-signature--generateTT">
                                    <Dropdown
                                        className="select tr__document-signature--generateTT select-generate"
                                        mode="select"
                                        dropdownPosition="center"
                                        placeholder="Generate TT"
                                        options={typeAddDocument.map((l) => {
                                            return {
                                                ...l,
                                                value: l.value
                                            }
                                        })}
                                        onChange={value => chooseTypeGenerateDoc(value, documentId)} />
                                </div>
                    }
                </div>
            )
        }
    ]

    const showDetails = (documentId, status) => {
        // setCurrentStatus(status.replaceAll('-', ' ').charAt(0).toUpperCase() + status.replaceAll('-', ' ').slice(1));
        setVerifyWalletModal(true);
        setIdDocumentSignature(documentId);
        setIdShipment(shipmentId);
    }

    const handleUploadDocument = (type) => {
        setUploadSignatureDocuments(true);
    }

    return (
        <>
            <div className="tr__document-signature">
                <div className="tr__document-signature--title d-flex align-items-center justify-content-between">
                    <h2 className="h2 f-medium">{t("home.active-shipment.details.tabs.document-signature")}</h2>
                    <div className="tr__document-signature--btn-add-doc">
                        <Button
                            type="secondary"
                            className="outline"
                            onClick={handleUploadDocument}
                        >Upload document
                        </Button>
                    </div>
                </div>
                <div className="tr__document-signature--content" id="document-signature">
                    <Table
                        className="document-signature"
                        columns={columns}
                        dataSource={documents}
                    >
                        <div className="tr__document-signature--table-header flex align-items-center justify-content-between table-header">
                            <div className="column name">
                                <p>{t("home.active-shipment.details.tabs.signatures.name")}</p>
                            </div>
                            <div className="column type">
                                <p>{t("home.active-shipment.details.tabs.signatures.type")}</p>
                            </div>
                            <div className="column members">
                                <p>{t("home.active-shipment.details.tabs.signatures.updated-by")}</p>
                            </div>
                            <div className="column partners">
                                <p>{t("home.active-shipment.details.tabs.signatures.partner")}</p>
                            </div>
                            <div className="column status">
                                <p>{t("home.active-shipment.details.tabs.signatures.status")}</p>
                            </div>
                            <div className="column actions">
                                <p>{t("home.active-shipment.details.tabs.signatures.actions")}</p>
                            </div>
                        </div>
                    </Table>
                </div>
                <div className="tr__document-signature--footer d-flex align-items-center justify-content-end">
                    {totalPagesDoc > 1 &&
                        <TableFooter
                            currentPage={currentPageDoc - 1}
                            totalPages={totalPagesDoc}
                            setCurrentPage={(page) => handlePageChange(page)}
                        />
                    }
                </div>
            </div>
            <DeleteConfirmation
                open={removeDoc}
                onCancel={() => setRemoveDoc(false)}
                onSubmit={deleteDoc}
                title="Remove confirmation"
                message={`Are you sure you want to remove ${documentNameDelete}?`}
            />
        </>
    )
}
